/** Factory for the trader family (EntityManager.spawnMob falls back to this). */

import type { MobType } from '../../game/types';
import type { Mob } from '../mob';
import { Llama } from './llama';
import { WanderingTrader } from './trader';

export const TRADER_MOB_TYPES: readonly MobType[] = ['wandering_trader', 'llama', 'trader_llama'];

export function createTraderMob(type: MobType, id: number, x: number, y: number, z: number, rnd: () => number): Mob | null {
  switch (type) {
    case 'wandering_trader': return new WanderingTrader(id, x, y, z, rnd);
    case 'llama': return new Llama(id, x, y, z, rnd, 'llama');
    case 'trader_llama': return new Llama(id, x, y, z, rnd, 'trader_llama');
    default: return null;
  }
}

export { Llama, WanderingTrader };

/**
 * Savanna and windswept chunks that rolled a herd: llamas in groups of 4-6
 * (0 = leave the chunk to the ordinary animals). Plains/savanna horse herds
 * keep the rest of the savanna rolls.
 */
export function llamaHerd(roll: number, sizeRoll: number, biome: string): number {
  if (!/savanna|windswept/.test(biome) || roll >= 0.3) return 0;
  return 4 + Math.floor(sizeRoll * 3);
}
